import React, { useState, useEffect } from 'react';
import { loginRequest } from '~/utils/ms-ad';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { Splash } from '~/components';
import { Col } from 'reactstrap';
import { useSession } from '@cordata/buffet';
import { Redirect, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const goHome = (history) => {
  setTimeout(() => history.push('/home'), 350);
};

const getToken = (instance, accounts, loginViaAzure, setToken, token, history) => {
  const account = accounts[0];

  const request = {
    ...loginRequest,
    account,
  };

  if (token) {
    return;
  }

  instance.acquireTokenSilent(request)
    .then(response => response.accessToken)
    .then(authToken => loginViaAzure({ 'auth-token': authToken }))
    .then(() => goHome(history))
    .catch(() => {
      instance.acquireTokenRedirect(request)
        .then(response => response.accessToken)
        .then(authToken => loginViaAzure({ 'auth-token': authToken }))
        .then(() => goHome(history))
        .catch(() => goHome(history));
    });
};

const TokenFetcher = ({
  instance,
  accounts,
  accessToken,
  updateToken,
}) => {
  const history = useHistory();
  const { loginAzureAd, isAuthed } = useSession();

  useEffect(() => {
    if (accessToken || isAuthed) {
      return;
    }
    getToken(instance, accounts, loginAzureAd, updateToken, accessToken, history);
  });

  return (
    (isAuthed || accessToken) ? <Redirect to="/home" /> : <div />
  );
};

TokenFetcher.propTypes = {
  instance: PropTypes.instanceOf(Object).isRequired,
  accounts: PropTypes.instanceOf(Array).isRequired,
  accessToken: PropTypes.string.isRequired,
  updateToken: PropTypes.string.isRequired,
};

const AuthResponse = () => {
  const [accessToken, setAccessToken] = useState(null);
  const { instance, accounts } = useMsal();

  useEffect(() => {
    localStorage.removeItem('route-attempted');
  });

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
    >
      {/*
        the MsalAuthenticationTemplate forces a user to be
        logged in via Active Directory to render the child
        components.
      */}
      <Splash>
        <Col className="text-muted">
          Logging in with Microsoft.
          {accessToken}
          <TokenFetcher
            instance={instance}
            accounts={accounts}
            token={accessToken}
            updateToken={setAccessToken}
          />
        </Col>
      </Splash>
    </MsalAuthenticationTemplate>
  );
};

export default AuthResponse;
